module.exports = __webpack_public_path__ + "img/bonus3.8b9e1bf5.png";